
// utils/apiFetch.js
export function apiFetch(url, options = {}) {
  const rnd = Math.floor(Math.random() * 1000000);
  const separator = url.includes('?') ? '&' : '?';
  const urlWithRnd = `${url}${separator}_rnd=${rnd}`;
  return fetch(urlWithRnd, options);
}
